module.exports = new __parcel__URL__("Software Arch Review.baf8365c.svg").toString();